import { render, staticRenderFns } from "./ModalInputCategory.vue?vue&type=template&id=ce87f7bc&scoped=true"
import script from "./ModalInputCategory.vue?vue&type=script&lang=js"
export * from "./ModalInputCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalInputCategory.vue?vue&type=style&index=0&id=ce87f7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce87f7bc",
  null
  
)

export default component.exports